<section
  *ngIf="{
    headerTitle: headerTitle$ | async,
    currentUser: currentUser$ | async,
    isAdmin: isAdmin$ | async
  } as STATE"
  class="settings-wrapper"
>
  <page-header></page-header>

  <section class="settings-wrapper__content card">
    <aside>
      <a
        routerLink="/settings/security"
        routerLinkActive="active"
        #securityRTA="routerLinkActive"
      >
        <p>
          <img
            class="illustration-icon"
            [lazyLoad]="
              securityRTA.isActive
                ? 'assets/icons/lock-white.svg'
                : 'assets/icons/lock.svg'
            "
            alt="security_icon"
          />
        </p>
        <p>
          <span>Sécurité</span>
          <span>Sécurisez l'accès à votre compte</span>
        </p>
      </a>
      @if (STATE.isAdmin) {
        <a
          routerLink="/settings/administrators"
          routerLinkActive="active"
          #usersRTA="routerLinkActive"
        >
          <p>
            <img
              class="illustration-icon"
              [lazyLoad]="
                usersRTA.isActive
                  ? 'assets/icons/user-group-white.svg'
                  : 'assets/icons/user-group.svg'
              "
              alt="users_icon"
            />
          </p>
          <p>
            <span>Administrateurs</span>
            <span>Gérez les administrateurs de la plateforme</span>
          </p>
        </a>
      }
    </aside>

    <main>
      <nav
        mat-tab-nav-bar
        mat-stretch-tabs="false"
        mat-align-tabs="start"
        color="primary"
        [tabPanel]="tabPanel"
        class="card__nav"
      >
        <a
          mat-tab-link
          routerLink="/settings/security"
          #security="routerLinkActive"
          [active]="security.isActive"
          routerLinkActive="tab-active-primary"
        >
          Sécurité
        </a>
        @if (STATE.isAdmin) {
          <a
            mat-tab-link
            routerLink="/settings/administrators"
            #users="routerLinkActive"
            [active]="users.isActive"
            routerLinkActive="tab-active-primary"
          >
            Administrateurs
          </a>
        }
      </nav>
      <mat-tab-nav-panel #tabPanel>
        <header *ngIf="STATE.headerTitle as title">{{ title }}</header>
        <ng-content></ng-content>
      </mat-tab-nav-panel>
    </main>
  </section>
</section>
